// In the native apps Turbo shows a page it has cached (a preloaded edit step
// page, say) as a preview straight away, then redraws it when the server's
// response arrives. That redraw replaces the body, disconnecting and
// reconnecting every controller on it, so native bridge buttons blink out and
// back in. When the response is the same markup as the preview, the redraw is
// skipped and the preview stays: it already is that page, with anything the
// person did on it in the meantime. Any other response renders as usual.

let preview = null;

const isNativeApp = () => document.documentElement.hasAttribute("data-turbo-native-app");

// A body's markup, less the authenticity tokens that differ on every render.
const markupOf = (body) => {
  const copy = body.cloneNode(true);
  copy.querySelectorAll("input[name='authenticity_token']").forEach((input) => input.removeAttribute("value"));
  return copy.innerHTML;
};

document.addEventListener("turbo:before-render", (event) => {
  if (!isNativeApp()) return;

  const { newBody } = event.detail;

  // Turbo marks the page as a preview before it asks to render one.
  if (document.documentElement.hasAttribute("data-turbo-preview")) {
    preview = { url: window.location.href, markup: markupOf(newBody) };
    return;
  }

  if (preview?.url === window.location.href && preview.markup === markupOf(newBody)) {
    event.detail.render = () => {};
  }
  preview = null;
});
